<template>
    <div
        v-show="breadcrumbs && breadcrumbs.length > 0"
        class="text-gray-600 text-sm mb-8 w-full"
    >
        <nav class="flex flex-wrap justify-between py-1">
            <ol class="list-reset flex">
                <li v-for="(crumb, index) in breadcrumbs" :key="index">
                    <a
                        class="text-sm text-gray-600 no-underline"
                        :class="{ 'font-semibold cursor-pointer': crumb.link }"
                        @click="routeTo(crumb)"
                    >
                        {{ crumb.name }}
                    </a>
                    <span v-if="index < breadcrumbs.length - 1" class="mx-2"
                        >/</span
                    >
                </li>
            </ol>
        </nav>
    </div>
</template>

<script>
export default {
    name: "Navbar",
    data() {
        return {
            breadcrumbs: []
        };
    },
    methods: {
        routeTo(crumb) {
            if (crumb.link) {
                this.$router.push({ name: crumb.link });
            }
        }
    },
    created() {
        this.breadcrumbs = this.$route.meta.breadcrumbs;
    },
    watch: {
        $route() {
            this.breadcrumbs = this.$route.meta.breadcrumbs;
        }
    }
};
</script>
